import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../app.settings';
import { CustomerData } from '../../customer/customer.model';
import { IdentityVerificationMethod, IdentityVerificationMethodLabel, IdentityVerificationStatus, IdentityVerificationStatusLabel } from 'common';
import { EnvelopeRecipientData, formatSignerStatus } from '../signing-widget/signing-widget.model';

@Component({
    selector: 'ifb-owners-widget',
    templateUrl: './owners-widget.component.html',
    styleUrls: ['./owners-widget.component.scss'],
    standalone: false
})
export class OwnersWidgetComponent implements OnChanges {
  @Input()
  owners: CustomerData[];

  @Input()
  salesforceViewMode: boolean;

  /** Recipients of the current DocuSign envelope; each owner who is one gets a signature caption. */
  @Input()
  signers: EnvelopeRecipientData[];

  signatureCaptions: Record<number, string> = {};

  readonly IdentityVerificationMethodLabel = IdentityVerificationMethodLabel;
  readonly IdentityVerificationMethod = IdentityVerificationMethod;
  readonly IdentityVerificationStatusLabel = IdentityVerificationStatusLabel;
  readonly IdentityVerificationStatus = IdentityVerificationStatus;

  constructor(private router: Router, private settings: AppSettings, private readonly datePipe: DatePipe) { }

  ngOnChanges(): void {
    this.signatureCaptions = Object.fromEntries((this.signers ?? [])
      .map((signer: EnvelopeRecipientData) => [signer.customerId, `Signature: ${formatSignerStatus(signer, this.datePipe)}`]));
  }

  customerDetailsLink(customer, newWindow: boolean = false) {
    const path = this.customerDetailsUri(customer);
    if (newWindow)
      window.open(path);
    else
      this.router.navigate([path]);
  }

  customerDetailsUri(customer) {
    if (this.salesforceViewMode) {
      return `/customer/sf/${customer.uniqueId}/profile`;
    }
    return `/customer/${customer.id}/profile`;
  }

  salesforceLink(salesforceRecordId: string) {
    return this.settings.salesforce.url + salesforceRecordId;
  }
}
